/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "device": {
                            "nested": {
                              "SquareHardwareSettings": {
                                "fields": {
                                  "generalSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.device.GeneralSettings",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "networkSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.device.NetworkSettings",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "displaySettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.device.DisplaySettings",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "soundSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.device.SoundSettings",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "accessibilitySettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.device.AccessibilitySettings",
                                    "id": 5,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "GeneralSettings": {
                                "fields": {}
                              },
                              "NetworkSettings": {
                                "fields": {}
                              },
                              "DisplaySettings": {
                                "fields": {}
                              },
                              "SoundSettings": {
                                "fields": {}
                              },
                              "AccessibilitySettings": {
                                "fields": {}
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.device?.nested?.SquareHardwareSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.device?.nested?.GeneralSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.device?.nested?.NetworkSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.device?.nested?.DisplaySettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.device?.nested?.SoundSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.device?.nested?.AccessibilitySettings) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE SquareHardwareSettings @ squareup/devicesettings/profiles/v2/model/settings/device/square_hardware_settings.proto at 20:1
 */
export const SquareHardwareSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.device.SquareHardwareSettings');
fixType(SquareHardwareSettings);
Builder.createAndAttachToType(SquareHardwareSettings);
/**
 * SOURCE GeneralSettings @ squareup/devicesettings/profiles/v2/model/settings/device/square_hardware_settings.proto at 51:1
 */
export const GeneralSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.device.GeneralSettings');
fixType(GeneralSettings);
Builder.createAndAttachToType(GeneralSettings);
/**
 * SOURCE NetworkSettings @ squareup/devicesettings/profiles/v2/model/settings/device/square_hardware_settings.proto at 55:1
 */
export const NetworkSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.device.NetworkSettings');
fixType(NetworkSettings);
Builder.createAndAttachToType(NetworkSettings);
/**
 * SOURCE DisplaySettings @ squareup/devicesettings/profiles/v2/model/settings/device/square_hardware_settings.proto at 59:1
 */
export const DisplaySettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.device.DisplaySettings');
fixType(DisplaySettings);
Builder.createAndAttachToType(DisplaySettings);
/**
 * SOURCE SoundSettings @ squareup/devicesettings/profiles/v2/model/settings/device/square_hardware_settings.proto at 63:1
 */
export const SoundSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.device.SoundSettings');
fixType(SoundSettings);
Builder.createAndAttachToType(SoundSettings);
/**
 * SOURCE AccessibilitySettings @ squareup/devicesettings/profiles/v2/model/settings/device/square_hardware_settings.proto at 67:1
 */
export const AccessibilitySettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.device.AccessibilitySettings');
fixType(AccessibilitySettings);
Builder.createAndAttachToType(AccessibilitySettings);